import { useNavigate } from "react-router-dom";

const CTASection = ({ className = "" }) => {
    const navigate = useNavigate();

    return (
        <section className={`py-24 px-4 md:px-12 lg:px-20 ${className}`}>
            <div className="max-w-5xl mx-auto">
                <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary via-primary/90 to-secondary p-8 md:p-12 lg:p-16 shadow-2xl">
                    {/* Background decoration */}
                    <div className="absolute inset-0 overflow-hidden pointer-events-none">
                        <div className="absolute -top-24 -right-24 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
                        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
                    </div>

                    <div className="relative z-10 text-center">
                        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-white mb-4">
                            Ready to Transform Your Trading?
                        </h2>
                        <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto mb-8">
                            Join thousands of Indian traders using AI to make smarter investment decisions.
                            Start your free trial today — no credit card required.
                        </p>

                        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                            <button
                                className="btn btn-lg bg-white text-primary hover:bg-white/90 border-0 shadow-xl px-8"
                                onClick={() => navigate('/signup')}
                            >
                                Get Started — It's Free
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                </svg>
                            </button>
                            <button
                                className="btn btn-lg btn-ghost text-white hover:bg-white/10 border border-white/30"
                                onClick={() => navigate('/signin')}
                            >
                                Sign In
                            </button>
                        </div>

                        <p className="text-white/60 text-sm mt-6">
                            ✓ No credit card required &nbsp;&nbsp; ✓ 14-day free trial &nbsp;&nbsp; ✓ Cancel anytime
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTASection;
